var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    Timezone: "+_vm._s(_vm.timezoneString)+"\n    "),_c('br'),_vm._v("\n    Timezones are set by the zipcode option and may require a browser refresh to update.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }